"use client";

import React from "react";
import Image from "next/image";
import MobileWorkItem from "./MobileWorkItem";
import { workImages } from "../data/images";
import { Button } from "@/components/ui/button";
import { scrollToSection } from "@/lib/utils";

const MobileOurWorkSection: React.FC = () => {
  return (
    <section id="design-workk" className="sm:hidden relative mt-14 w-full">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 h-full">
        <div className="relative h-full w-full">
          <Image
            src="/images/OurWork.png"
            alt="Our work showcase"
            fill
            priority
            className="object-fill"
          />
          <div className="absolute inset-0 bg-black/45" />
        </div>
      </div>

      {/* Overlay with content */}
      <div className="relative z-10 px-4 py-10 pb-5">
        {/* Heading */}
        <div className="text-center mb-10">
          <h2 className="text-4xl font-medium tracking-wide text-white">
            Our Work
          </h2>
        </div>

        {/* Work Items */}
        <div className="space-y-5">
          {workImages.map((image, index) => (
            <MobileWorkItem
              key={index}
              src={image.src}
              alt={image.alt}
              title={image.title}
              description={image.description}
              index={index}
            />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 mb-10 text-white">
          <p className="text-2xl mb-4 leading-tight">
            We Make Our Clients Shine in the Digital Space
          </p>
          <Button
            onClick={() => scrollToSection("contact-us")}
            className="bg-white hover:bg-primary-sky text-primary font-normal"
          >
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MobileOurWorkSection;
